import {formatNumberWithGrouping} from "@/data/sources/numbers"

export function aggregateSpaceStatus(data: any[]): object {
  class Category {
    private label: string | undefined
    private value: number
    private toolText: string | undefined
    private color: string
    private category: Category[] = []

    constructor(label: string | undefined, value: number, toolText: string | undefined, color: string) {
      this.label = label
      this.value = value
      this.toolText = toolText
      this.color = color
    }

    public getValue(): number {
      return this.value
    }

    public setToolText(toolText: string) {
      this.toolText = toolText
    }

    public addCategory(category: Category): void {
      this.value += category.value
      this.category.push(category)
      // this.toolText = this.label + " - " + formatNumberWithGrouping(this.value) + " sqm"
    }
  }

  const higherCategories: Map<string, Category> = new Map<string, Category>()
  const groupTitles: Map<string, { title: string, colour: string }> = new Map<string, { title: string, colour: string }>([
    ["una", {title: "Unassigned Area", colour: "#FF0000"}],
    ["cli", {title: "Clinical Space", colour: "#6DCC77"}],
    ["non", {title: "Non-Clinical Space", colour: "#6DA2CC"}],
    ["ret", {title: "Retail Sales Space", colour: "#A569BD"}],
    ["lea", {title: "Leased-out", colour: "#F3D385"}],
    ["uno", {title: "Unoccupied", colour: "#C0C0C0"}],
  ])
  const totalArea = data.reduce((sum, item) => sum + item.roomarea, 0)
  /*
    0: {cp_value: "Clinical Space - Clinical Space Other S02_10", roomarea: 875.46, roomcount: 48, colour: "#6DCC77"}
    1: {cp_value: "Clinical Space - Pathology Chemical S02_08", roomarea: 45.86, roomcount: 4, colour: "#6DCC77"}
    2: {cp_value: "Non-Clinical Space - Non-clinical Space - Other S02_17", roomarea: 354.76, roomcount: 28, colour: "#6DA2CC"}
  */
  for (const item of data) {
    const categoryLabel: string = item.cp_value
    const categoryValue: number = item.roomarea
    const categoryColour: string = item.colour
    const category: Category = new Category(
      undefined, categoryValue,
      categoryLabel + " - " + formatNumberWithGrouping(categoryValue) + " Sq.m, " + formatNumberWithGrouping(100 * categoryValue / totalArea) + "%",
      categoryColour)
    const prefix = categoryLabel.substring(0, 3).toLowerCase()
    const title = (groupTitles.get(prefix) || {title: "Unknown"}).title
    const higherCategory = higherCategories.get(prefix) || new Category(title, 0, "$label - $value Sq.m, $percentValue", categoryColour)
    higherCategories.set(prefix, higherCategory)
    higherCategory.addCategory(category)
    higherCategory.setToolText(title + " - " + formatNumberWithGrouping(higherCategory.getValue()) + " Sq.m, "
      + formatNumberWithGrouping(100 * higherCategory.getValue() / totalArea) + "%")
  }
  const rootCategory = new Category("Total Floor Area:{br}" + formatNumberWithGrouping(totalArea) + " Sq.m", 0, undefined, "#ffffff")
  higherCategories.forEach((category) => rootCategory.addCategory(category))
  return rootCategory
}
